import { render, staticRenderFns } from "./UnderlyingDetailsHeader.vue?vue&type=template&id=a89fa65c&"
import script from "./UnderlyingDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./UnderlyingDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports